export default __webpack_public_path__ + "static/montserrat-5dada3d32f3761187edeb191b548c571.woff";